import Vue from 'vue'
import VueApexCharts from "vue-apexcharts"

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

window.Apex.colors = [ '#DA291C', '#FEC900', '#7f7f7f', '#00AF6E', '#2299D4', '#000' ]
window.Apex.chart = { fontFamily: "Brown, sans-serif" };
